// extracted by mini-css-extract-plugin
export default {"loaderCss":"ClientReports_loaderCss__5xYhq"};